<mat-chip-grid #chipGrid aria-label="Type to search" matAutocompleteOrigin>
  @for (chip of value; track trackByIndex(i); let i = $index) {
    <mat-chip-row
      (removed)="removeChip(i)"
      [editable]="false"
      [aria-description]="'press enter to edit ' + chip"
      [class.invalid-chip]="invalidChips.includes(i)"
    >
      {{ chip }}
      <button matChipRemove>
        <mat-icon svgIcon="twc:close-xs" class="twc-fill-canvas" />
      </button>
    </mat-chip-row>
  }
  @if (!isAtMaxLength()) {
    <input
      #chipInput
      [id]="id"
      [placeholder]="!value.length ? placeholder : ''"
      [matChipInputFor]="chipGrid"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="true"
      (matChipInputTokenEnd)="addChip($event)"
      autocomplete="off"
      (paste)="onPaste($event)"
    />
  }
</mat-chip-grid>
